import { isSiteServed } from '@/lib/siteServed';

/**
 * Does the dashboard call this site "Live"?
 *
 * It has content (the build-state check says not empty) and the public web serves it — the
 * gateway's own rule (lib/siteServed.ts). Two older conditions made a live site read "Draft":
 * - `status === 'active'`: a PRIMARY site serves in `draft` too, and the Studio's Publish only
 *   flips the status of a site that isn't served, so a published primary can stay `draft`.
 * - a template marked applied: sites built through /build (looks + AI content) have none.
 * Unknown build state is not live yet (no flash of "Live" while it loads); an unloaded site
 * record keeps the old assumption that it serves.
 */
export function dashboardSiteIsLive(
  isEmpty: boolean | undefined,
  site: { status?: string | null; is_primary?: unknown } | null | undefined,
): boolean {
  if (isEmpty !== false) return false;
  return site ? isSiteServed(site) : true;
}
